<template>
  <div class="mr-3">
    <VueSlider
      v-model="localValue"
      :marks="true"
      @change="changed"
      :data="sliderData"
      :adsorb="true"
    />
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "@/assets/css/slider.css";
export default {
  name: "Slider",
  props: {
    sliderData: Array,
    initialValue: Number
  },
  components: {
    VueSlider
  },
  data() {
    return {
      componentKey: 0,
      localValue: this.initialValue
    };
  },
  methods: {
    changed(val) {
      this.$emit("radius", val);
    }
  },
  watch: {
    initialValue: function(newVal, oldVal) {
      this.localValue = newVal;
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    }
  }
};
</script>

<style></style>
